<template>
  <div>
    <p class="text-sm">
      {{ address.street }} {{ address.exterior_number
      }}{{ address.interior_number ? " " + address.interior_number : "" }}
    </p>
    <p v-if="address.neighborhood" class="text-sm">
      {{ address.neighborhood }}
    </p>
    <p class="text-sm">{{ address.city }}, {{ address.state.name }}</p>
    <p class="text-sm">México</p>
    <p class="text-sm">{{ address.zip_code }}</p>
    <div v-if="showShippingPrice">
      <p
        v-if="branchAddress.valid_for_shipping"
        class="font-semibold text-sm text-content-700"
      >
        {{
          branchAddress.shipping_price
            ? integerToCurrency(branchAddress.shipping_price) + " por envío"
            : "El precio de envío se calculará al enviar la orden"
        }}
      </p>
      <p v-else class="font-semibold text-sm text-error-500">
        Esta dirección no es válida para envíos de tu sucursal.
      </p>
    </div>
  </div>
</template>

<script>
import { integerToCurrency } from "@/utils/currencyFormatter";
export default {
  name: "Address Info",

  props: {
    address: Object,
    showShippingPrice: Boolean,
    branchId: Number,
  },

  computed: {
    branchAddress() {
      const branch = this.address.branches.filter(
        (br) => br.id === this.branchId
      )[0];

      if (!branch) {
        return {
          valid_for_shipping: false,
          shipping_price: null,
        };
      }

      return branch.pivot;
    },
  },

  methods: {
    integerToCurrency,
  },
};
</script>